export default __webpack_public_path__ + "static/media/unlock.657c123f.svg";